/**
 * Enum representation of a standard unit of time
 */
export enum TimeUnit {
    Millisecond = 1,
    Second = Millisecond * 1000,
    Minute = Second * 60,
    Hour = Minute * 60,
    Day = Hour * 24,
    Week = Day * 7,
    Month = Day * 30,
    Year = Day * 365,
}
